import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/apiKeys.json';
import ar from './i18n/ar/apiKeys.json';

registerFeatureI18n('apiKeys', { en, ar });

export { ApiKeysPage } from './ApiKeysPage';
